import { xcss, Box } from '@atlaskit/primitives';

import { defineMessages, FormattedMessage } from 'react-intl';

const centeredContentStyles = xcss({
  textAlign: 'center',
});

const messages = defineMessages({
  title: {
    id: 'heading',
    defaultMessage: 'Someone is requesting access to your Atlassian account',
    description: 'Heading for oauth',
  },
});

const Header = () => (
  <Box xcss={centeredContentStyles}>
    <FormattedMessage {...messages.title} tagName="h1" />
  </Box>
);

export default Header;
